import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

import GetAppIcon from '@material-ui/icons/GetApp';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import WarningIcon from '@material-ui/icons/Warning';
import RefreshIcon from '@material-ui/icons/Refresh';

import pollOrderStatus from "../functions/pollOrderStatus";

const useStyles = makeStyles({
    orderItem: {
        padding: 10,
        border: '1px solid #D2D2D8',
        width: '98%',
        marginBottom: 5,
        '& .MuiOutlinedInput-root':{
            height:30
        },
        color: '#000',
    },
    productLabel:{
        marginBottom: 10,
    },
    productFormat:{
        minWidth: 100
    },
    textItemFont:{
        fontSize:11
    },
    productSelectButton: {
        marginLeft: 20,
        marginTop: 5,
    },
    downloadIcon: {
        width: 16,
        height: 16
    },
    downloadButton: {
        marginTop: 10,
        height: 28,
        width: '90%',
        minWidth: 120,
        maxWidth: 180,
        backgroundColor:'#0C4C35',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#63D764'
        },
    },
    reloadButton: {
        marginTop: 10,
        height: 28,
        width: '90%',
        minWidth: 120,
        maxWidth: 180,
        backgroundColor:'#71b99f',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#63D764'
        },
    },
});

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);


export default function OrderItemCard(props) {
  const classes = useStyles();
  const [action, setAction] = useState([]);
  const [products, setProducts] = useState([]);
  const [orderStatus, setOrderStatus] = useState(props.item.status);
  const [canRequest, setCanRequest] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [syncToolTip, setSyncToolTip] = useState("Select to sync your order with the newest dataset releases.");

  useEffect(() => { 
    let today = new Date();
    let lastordered = new Date(props.item.lastordered);
    lastordered.setDate(lastordered.getDate() + 2);

    const orderType = props.item.ordertype.charAt(0).toUpperCase() + props.item.ordertype.slice(1);
    setAction(orderType);

    let productarray = props.item.products.replace("{","");
    productarray = productarray.replace("}","");
    productarray = productarray.replace(/"/g,"");
    const parray = productarray.split(",");
    let display =[];
    parray.forEach(function (item) {
      let i = item.split("-");
      let label = i[0];
      let format = '';
      if (props.item.ordertype !== 'print') { format = " ("+i[1]+")"; }
      display.push(label+format);
      if (label.includes('MasterMap') && orderType === 'Export') setCanRequest(true); //Set to allow refresh of OS MM.
      if (today > lastordered) setCanUpdate(true); 
    });
    
    setProducts(display);
  },[props.item.products, props.item.lastordered,props.item.ordertype])

  const handleDownloadClick = () => {
        props.handleClick(props.item.orderid);
  }

    const handleDataRefreshClick = () => {
        setOrderStatus('processing');
        props.handleDataRefreshClick(props.item.orderid);
        startOrderPolling();
    }

    const startOrderPolling = async() => {
        let counter = 0;
        let timer = window.setInterval(async function(){
            counter++;
            let s = await pollOrderStatus(props.userid, props.item.orderid, props.ident);
            if (s !== 0) setOrderStatus(s);
            if (counter >= 5 || s === "completed") clearInterval(timer); setCanUpdate(false);
        }, 10000);
    }

    /*
    {canRequest ? (
        <HtmlTooltip title={<React.Fragment>{syncToolTip}</React.Fragment>}>
            <span><Button className={classes.reloadButton} variant="contained" disabled={!canUpdate} onClick={() => {handleDataRefreshClick()} }>
                <Box p={1} display="flex" ><RefreshIcon className={classes.downloadIcon} /></Box><Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Update</Box>
            </Button></span>
        </HtmlTooltip>
    ) : ( '' )}
     */

    function renderStatusButton(orderStatus, classes) {
        switch (orderStatus) {
            case 'expired':
                return (
                    <HtmlTooltip title={<React.Fragment>{"Your license for this order has expired."}</React.Fragment>}>
                    <span><Button className={classes.downloadButton} variant="contained" disabled={true}>
                        <Box p={1} display="flex"><WarningIcon className={classes.downloadIcon} /></Box>
                        <Box p={1} fontWeight="fontWeightRegular" fontSize={12}>Expired</Box>
                    </Button></span>
                    </HtmlTooltip>
                );
            case 'ordered':
            case 'reordered':
            case 'processing':
                return (
                    <HtmlTooltip title={<React.Fragment>{"Your order is prcoessing."}</React.Fragment>}>
                        <span><Button className={classes.downloadButton} variant="contained" disabled={true} >
                            <Box p={1} display="flex" ><AutorenewIcon className={classes.downloadIcon} /></Box><Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Processing</Box>
                        </Button></span>
                    </HtmlTooltip>
                );
            case 'completed':
                return (
                    <div>
                    <HtmlTooltip title={<React.Fragment>{"Select to download your order"}</React.Fragment>}>
                        <span><Button className={classes.downloadButton} variant="contained" disabled={false} onClick={() => {handleDownloadClick()} }>
                            <Box p={1} display="flex" ><GetAppIcon className={classes.downloadIcon} /></Box><Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Download</Box>
                        </Button></span>
                    </HtmlTooltip>
                    </div>
                );
            case 'void':
                return (
                    <span><Button className={classes.downloadButton} variant="contained" disabled={true} >
                        <Box p={1} display="flex" ><WarningIcon className={classes.downloadIcon} /></Box><Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Voided</Box>
                    </Button></span>
                );
            default:
                return null;
        }
    }
     
  return (
    <div className={classes.orderItem}>
        <Grid container>
            <Grid item xs={4} md={4}><Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >Order Placed: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={14} >{props.item.orderdate}</Box></Box></Grid>
            <Grid item xs={4} md={6}><Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >Order By: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={14} >{props.item.username}</Box></Box></Grid>
            <Grid item xs={4} md={2}><Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >Order #: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={14} >{props.item.orderid}</Box></Box></Grid>
            <Grid item xs={4} md={4}>
                <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Project Reference: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >{props.item.projectname}</Box></Box>
                <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >PO Number:&nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >{props.item.userref}</Box></Box> 
                <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Action: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >{action}</Box></Box>
            </Grid>
            <Grid item xs={4} md={4}>
                <Box fontWeight="fontWeightBold" fontSize={12} >Product items:</Box>
                {products.map((item, i) =>
                    <Box key={i} fontWeight="fontWeightRegular" fontSize={12} >{item}</Box>  
                )}
            </Grid>
            <Grid item xs={2} md={2}>
                <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Net: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >&nbsp;&nbsp;£{props.item.price}</Box></Box>
                <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >VAT: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >&nbsp;&nbsp;£{props.item.vat}</Box></Box>
                <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Total: &nbsp;</Box><Box fontWeight="fontWeightRegular" fontSize={12} >£{props.item.total}</Box></Box>
            </Grid>
            <Grid item xs={2} md={2}>
                {renderStatusButton(orderStatus, classes)}
            </Grid>
        </Grid>
    </div>

  );
}